module.exports = __webpack_public_path__ + "img/natural-methods_x2.9a51aedf.png";